// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import useGetCurrentProduct from "@store/Framework/Store/Data/Products/ProductsHooks/useGetCurrentProduct";
import { SubAvailabilityTypes } from "@store/Framework/Types/SubAvailabilityTypes";

export interface InventoryData {
    availabilityType: SubAvailabilityTypes;
    availabilityMessage: string | undefined;
    availabilityMessageColor: string | undefined;
    availabilityIcon: string | undefined;
    availabilityInfoMessageColor: string | undefined;
    availabilityInfoMessageIcon: string | undefined;
    qtyOnHand: number | undefined;
    isInStock: boolean;
    isOutOfStock: boolean;
    isBackorder: boolean;
    isWhileSuppliesLast: boolean;
    availabilityDetailMessage: string | undefined;
}

interface InventoryStatusData {
    infoMessage: string | undefined;
    messageColor: string | undefined;
    messageIcon: string | undefined;
    availabilityIcon: string | undefined;
    infoMessageColor: string | undefined;
    infoMessageIcon: string | undefined;
    subMessageType: SubAvailabilityTypes | undefined;
    preventAddToCart: boolean | undefined;
}

export default (productInfo: ProductInfo | null = null): InventoryData => {
    const productContext = useGetCurrentProduct();
    const definedProductInfo = productContext.productInfo || productInfo || {};
    const { inventory } = definedProductInfo;
    const inventoryStatus: Partial<InventoryStatusData> = inventory?.additionalResults || {};
    const qtyOnHand = inventory?.qtyOnHand;
    const availability = inventory?.inventoryAvailabilityDtos?.find(
        x => x.unitOfMeasure === definedProductInfo.unitOfMeasure,
    )?.availability;
    const availabilityDetailMessage =
        inventoryStatus?.infoMessage !== availability?.message ? inventoryStatus?.infoMessage : undefined;
    const subMessageType: SubAvailabilityTypes = (availability as any)?.subMessageType;

    const availabilityMessageColor = inventoryStatus.messageColor;
    const availabilityIcon = inventoryStatus.messageIcon;
    const availabilityInfoMessageColor = inventoryStatus.infoMessageColor;
    const availabilityInfoMessageIcon = inventoryStatus.infoMessageIcon;
    const inventoryData: InventoryData = {
        availabilityType: subMessageType,
        availabilityMessage: availability?.message,
        availabilityMessageColor,
        availabilityIcon,
        availabilityInfoMessageColor,
        availabilityInfoMessageIcon,
        qtyOnHand,
        isInStock: subMessageType === SubAvailabilityTypes.InStock,
        isOutOfStock: subMessageType === SubAvailabilityTypes.OutOfStock,
        isBackorder: subMessageType === SubAvailabilityTypes.Backorder,
        isWhileSuppliesLast: subMessageType === SubAvailabilityTypes.WhileSuppliesLast,
        availabilityDetailMessage,
    };

    return inventoryData;
};
